import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AddressModel, AddressUpdateParams } from '../../models/address';
import { ApiProvider } from '../api/api';
import { ServiceModel } from '../../models/service';

@Injectable()
export class AddressProvider {
  constructor(private api: ApiProvider) {}
  updateAddressInfo(uid: string, addressParams: AddressUpdateParams) {
    const request = this.api
      .call({
        url: `/addresses/${uid}`,
        ops: true,
        body: addressParams,
        method: 'PATCH',
      })
      .map(item => {
        return new AddressModel(item);
      });
    return request;
  }

  getServicesForAddress(uid: string): Observable<ServiceModel[]> {
    const request = this.api
      .call({
        url: `/user_addresses/${uid}/services`,
        ops: true,
      })
      .map(res => res.map(item => new ServiceModel(item)));
    return request;
  }
}



// WEBPACK FOOTER //
// ./src/providers/address/address.ts